"use client";

import { Button } from "@/components/shadcn/button";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/shadcn/popover";
import { useSession } from "@/lib/auth/client";
import { Crown, Swords } from "lucide-react";
import { lazy, useState } from "react";

const CreateGameDialog = lazy(() =>
    import("@/app/oyun/_components/CreateGameDialog").then((m) => ({
        default: m.CreateGameDialog,
    })),
);

interface PlayerNicknameProps {
    nickname: string;
    isPremium?: boolean;
    userId?: number;
    className?: string;
    iconSize?: number;
}

export function PlayerNickname({
    nickname,
    isPremium,
    userId,
    className,
    iconSize = 18,
}: PlayerNicknameProps) {
    const { data: session } = useSession();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const nicknameContent = (
        <span
            className={
                className ?? "inline-flex items-center gap-1 font-medium"
            }
        >
            {nickname}
            {isPremium && (
                <Crown
                    width={iconSize}
                    height={iconSize}
                    className="text-primary"
                />
            )}
        </span>
    );

    const canInvite =
        userId != null && session?.user != null && session.user.id !== userId;

    if (!canInvite) {
        return nicknameContent;
    }

    return (
        <>
            <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
                <PopoverTrigger asChild>
                    <button
                        type="button"
                        className="inline cursor-pointer appearance-none border-0 bg-transparent p-0 text-left"
                        onMouseEnter={() => setPopoverOpen(true)}
                        onMouseLeave={() => setPopoverOpen(false)}
                    >
                        {nicknameContent}
                    </button>
                </PopoverTrigger>
                <PopoverContent
                    className="w-auto p-2"
                    onMouseEnter={() => setPopoverOpen(true)}
                    onMouseLeave={() => setPopoverOpen(false)}
                    onOpenAutoFocus={(e) => e.preventDefault()}
                >
                    <Button
                        size="sm"
                        variant="ghost"
                        className="gap-2"
                        onClick={() => {
                            setPopoverOpen(false);
                            setDialogOpen(true);
                        }}
                    >
                        <Swords className="h-4 w-4" />
                        Oyuna Davet Et
                    </Button>
                </PopoverContent>
            </Popover>
            {dialogOpen && (
                <CreateGameDialog
                    open={dialogOpen}
                    onOpenChange={setDialogOpen}
                    inviteTarget={nickname}
                />
            )}
        </>
    );
}
